import { render } from "./DashboardPermission.vue?vue&type=template&id=3077025a&scoped=true"
import script from "./DashboardPermission.vue?vue&type=script&lang=js"
export * from "./DashboardPermission.vue?vue&type=script&lang=js"

import "./DashboardPermission.vue?vue&type=style&index=0&id=3077025a&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3077025a"]])

export default __exports__